angular.module("tasks_types")

    .controller("TasksTypesEditCtrl", ['LoginService', '$scope', '$rootScope', '$state', '$stateParams', 'Restangular',  '$filter', 'modalService',
        function (LoginService, $scope, $rootScope, $state, $stateParams, Restangular,  $filter,  modalService) {
        
        //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("TASKS_TYPES_WRITE");
        $rootScope.title = $filter('translate')('tasks_types.title');

        $scope.task_types = {};
        $scope.selectEntityTypes = [{ id: 'events', name: $filter("translate")('entity_types.events') }, { id: 'correspondence', name: $filter("translate")('entity_types.correspondence') }];;

        if (angular.isUndefined($stateParams.id) || $stateParams.id == "") {
       
            $rootScope.breadcrumb = [
                { title: $filter('translate')('tasks_types.title'), url: "tasks_types.list" },
                { title: $filter('translate')('tasks_types.title_add') },
            ];
             
        } else {
            $rootScope.breadcrumb = [
                { title: $filter('translate')('tasks_types.title'), url: "tasks_types.list" },
                { title: $filter('translate')('tasks_types.title_edit') },
            ];

            Restangular.one('TasksTypes', $stateParams.id).get().then(function (result) {                
                $scope.task_types = result;                
            });
        }               
                                       
            $scope.saveTaskTypes = function () {            
            if (angular.isDefined($scope.task_types.id)) {
                $scope.task_types.put().then(function (result) {
                    if (angular.isDefined(result.id)) {
                        toastr.success($filter('translate')('tasks_types.edit_success'));                        
                        $state.go("tasks_types.list");
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            } else {
                Restangular.all('TasksTypes').post($scope.task_types).then(function (result) {
                    if (angular.isDefined(result.id)) {
                        toastr.success($filter('translate')('tasks_types.save_success'));
                        $state.go("tasks_types.list");
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            }
        }

        $scope.checkDelete = function () {
            modalService.confirm({
                title: $filter('translate')('tasks_types.button_delete'),
                message: $filter('translate')('tasks_types.delete_message') + " " + $scope.task_types.name + "?",
                onAccept: function () {
                    $scope.task_types.remove().then(function () {
                        toastr.success($filter('translate')('tasks_types.deleted_success'));
                        $state.go("tasks_types.list");
                    });
                }
            });
        };        

}])

;

